import React, { useState, useEffect, useRef } from 'react';
import { v4 as generateUUID } from 'uuid';
import { getMfaFactors, sendOtp, verifyOtp } from '../../api/apiService.ts';
import { useAuth0 } from '@auth0/auth0-react';
import Footer from '../../components/Footer/Footer.tsx';
import './ForgotUsername.scss';
import { fetchPageContent } from '../../utils/contentful/Constants.ts';
import Header from '../../components/Header/Header.tsx';

type FormDataType = {
  email: string;
  lastName: string;
  dob: string;
  tempPin: string;
};

type FieldType = keyof FormDataType;

type ErrorMessagesType = {
  [key in FieldType]: {
    required?: string;
    invalid?: string;
  };
};

type MFAFactorType = {
  created_at: string;
  email: string;
  email_verified: boolean;
  app_metadata?: {
    MFA_phone_number?: string;
  };
  phone_verified?: boolean;
  multifactor?: string[];
  name: string;
  nickname: string;
  picture: string;
  updated_at: string;
  user_id: string;
  username: string;
  logins_count: number;
  last_ip: string;
  last_login: string;
  identities: Array<{
    connection: string;
    provider: string;
    user_id: string;
    isSocial: boolean;
  }>;
};

const ForgotUsername: React.FC = () => {
  const [, setTranslations] = useState<any>({});
  const { loginWithRedirect } = useAuth0();

  const [currentStep, setCurrentStep] = useState(1);

  const [selectMethod, setSelectMethod] = useState<string>('email');
  const [success, setSuccess] = useState('');
  const [tempPin, setTempPin] = useState('');
  const dobRef = useRef<any>(null);
  const [formData, setFormData] = useState({
    email: '',
    lastName: '',
    dob: '',
    tempPin: '',
  });

  const [errors, setErrors] = useState({
    email: '',
    lastName: '',
    dob: '',
    tempPin: '',
    general: '',
  });

  const [, setLoading] = useState(false);
  const [, setError] = useState(null);
  const [mfaFactors, setMfaFactors] = useState<MFAFactorType>();
  const [userDetails, setUserDetails] = useState({
    email: '',
    phoneNumber: '',
  });
  const [channel, setChannel] = useState<"sms" | "call">("sms");
  const [transactionId, setTransactionId] = useState('');
  

  const [ForgotUsernamestep1text, setForgotUsernamestep1text] = useState('');
  const [ForgotUsernamestep1description, setForgotUsernamestep1description] = useState('');
  const [ForgotUsernamelastName, setForgotUsernamelastName] = useState('');
  const [ForgotUsernameDateofBirth, setForgotUsernameDateofBirth] = useState('');
  const [ForgotUsernameEmail, setForgotUsernameEmail] = useState('');
  const [ForgotUsernameBack, setForgotUsernameBack] = useState('');
  const [ForgotUsernameNext, setForgotUsernameNext] = useState('');
  const [ForgotUsernameemailError, setForgotUsernameemailError] = useState('');
  const [ForgotUsernamevalidateEmailError, setForgotUsernamevalidateEmailError] = useState('');
  const [ForgotUsernamelastNameError, setForgotUsernamelastNameError] = useState('');
  const [ForgotUsernamevalidatelastNameError, setForgotUsernamevalidatelastNameError] = useState('');
  const [ForgotUsernamedobError, setForgotUsernamedobError] = useState('');
  const [ForgotUsernamevalidatedobError, setForgotUsernamevalidatedobError] = useState('');
  const [ForgotUsernametemporaryPinRequiredError, setForgotUsernametemporaryPinRequiredError] = useState('');
  const [ForgotUsernametemporaryPinInvalidError, setForgotUsernametemporaryPinInvalidError] = useState('');
  const [ForgotUsernamestep2text, setForgotUsernamestep2text] = useState('');
  const [ForgotUsernamestep2description, setForgotUsernamestep2description] = useState('');
  const [ForgotUsernameStep2Back, setForgotUsernameStep2Back] = useState('');
  const [ForgotUsernameStep2sendCode, setForgotUsernameStep2sendCode] = useState('');
  const [ForgotUsernameStep2channelHeading, setForgotUsernameStep2channelHeading] = useState('');
  const [ForgotUsernameStep3emailTitle, setForgotUsernameStep3emailTitle] = useState('');
  const [ForgotUsernameStep3phoneTitle, setForgotUsernameStep3phoneTitle] = useState('');
  const [ForgotUsernameStep3pinPrompt, setForgotUsernameStep3pinPrompt] = useState('');
  const [ForgotUsernameStep3tempPin, setForgotUsernameStep3tempPin] = useState('');
  const [ForgotUsernameStep3textPrompt, setForgotUsernameStep3textPrompt] = useState('');
  const [ForgotUsernameStep3textPromptSms, setForgotUsernameStep3textPromptSms] = useState('');
  const [ForgotUsernameStep3textPromptCall, setForgotUsernameStep3textPromptCall] = useState('');
  const [ForgotUsernameStep3buttonsResend, setForgotUsernameStep3buttonsResend] = useState('');
  const [ForgotUsernameStep3Back, setForgotUsernameStep3Back] = useState('');
  const [ForgotUsernameStep3Next, setForgotUsernameStep3Next] = useState('');
  const [ForgotUsernameStep3emailmessage, setForgotUsernameStep3emailmessage] = useState('');
  const [ForgotUsernameStep3phoneMessage, setForgotUsernameStep3phoneMessage] = useState('');
  const [ForgotUsernameStep3callMessage, setForgotUsernameStep3callMessage] = useState('');

  useEffect(() => {
    fetchPageContent()
      .then((data: Record<string, any>) => {
        console.log('🔍 Contentful Translations:', data);
        setTranslations(data);
        const foundName = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-1-heading',
        )?.fields?.title;
        setForgotUsernamestep1text(foundName);

        const foundDesc = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-1-content',
        ).fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernamestep1description(foundDesc);

        const foundlastName = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-config',
        ).fields.lastNameLabel;
        setForgotUsernamelastName(foundlastName);

        const founddob = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-config',
        ).fields.dateOfBirthLabel;
        setForgotUsernameDateofBirth(founddob);

        const foundEmail = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-config',
        ).fields.emailLabel;
        setForgotUsernameEmail(foundEmail);

        const foundBack = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-back-button',
        ).fields.text;
        setForgotUsernameBack(foundBack);

        const foundNext = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-next-button',
        ).fields.text;
        setForgotUsernameNext(foundNext);

        const foundemailError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.emailRequiredLabel;
        setForgotUsernameemailError(foundemailError);

        const foundvalidateEmailError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.emailInvalidLabel;
        setForgotUsernamevalidateEmailError(foundvalidateEmailError);

        const foundlastNameError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.lastNameRequiredLabel;
        setForgotUsernamelastNameError(foundlastNameError);

        const foundvalidatelastNameError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.lastNameInvalidLabel;
        setForgotUsernamevalidatelastNameError(foundvalidatelastNameError);

        const founddobError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.dateOfBirthRequiredLabel;
        setForgotUsernamedobError(founddobError);

        const foundvalidatedobError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.dateOfBirthInvalidLabel;
        setForgotUsernamevalidatedobError(foundvalidatedobError);

        const foundtemporaryPinRequiredError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.temporaryPinRequiredLabel;
        setForgotUsernametemporaryPinRequiredError(foundtemporaryPinRequiredError);

        const foundtemporaryPinInvalidError = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-error-messages',
        ).fields.temporaryPinInvalidLabel;
        setForgotUsernametemporaryPinInvalidError(foundtemporaryPinInvalidError);

        const foundStep2Name = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-2-heading',
        ).fields?.title;
        setForgotUsernamestep2text(foundStep2Name);

        const foundStep2Dec = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-2-content',
        ).fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernamestep2description(foundStep2Dec);

        const foundStep2Back = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-back-button',
        ).fields.text;
        setForgotUsernameStep2Back(foundStep2Back);

        const foundStep2sendCode = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-2-send-code-button',
        ).fields.text;
        setForgotUsernameStep2sendCode(foundStep2sendCode);

        const foundStep2channelHeading = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-2-channel-heading',
        )?.fields?.title;
        setForgotUsernameStep2channelHeading(foundStep2channelHeading);

        const foundStep3emailTitle = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step3-email-heading',
        ).fields.title;
        setForgotUsernameStep3emailTitle(foundStep3emailTitle);

        const foundStep3phoneTitle = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-phone-heading',
        ).fields.title;
        setForgotUsernameStep3phoneTitle(foundStep3phoneTitle);

        const foundStep3pinPrompt = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-pin-prompt-content',
        ).fields?.content?.content[0]?.content[0]?.value;

        setForgotUsernameStep3pinPrompt(foundStep3pinPrompt);

        const foundStep3tempPin = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-config',
        ).fields.temporaryPinLabel;
        setForgotUsernameStep3tempPin(foundStep3tempPin);

        const foundStep3textPrompt = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-text-prompt-content',
        ).fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3textPrompt(foundStep3textPrompt);

        const foundStep3textPromptSms = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-text-prompt-sms-content',
        )?.fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3textPromptSms(foundStep3textPromptSms);

        const foundStep3textPromptCall = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-text-prompt-call-content',
        )?.fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3textPromptCall(foundStep3textPromptCall);

        const foundStep3buttonsResend = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-request-a-new-code-button',
        ).fields.text;
        setForgotUsernameStep3buttonsResend(foundStep3buttonsResend);

        const foundStep3Back = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-back-button',
        ).fields.text;
        setForgotUsernameStep3Back(foundStep3Back);

        const foundStep3Next = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-next-button',
        ).fields.text;
        setForgotUsernameStep3Next('Continue');

        const foundStep3Step3emailmessage = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-email-content',
        ).fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3emailmessage(foundStep3Step3emailmessage);

        const foundStep3Step3phonemessage = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-phone-content',
        ).fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3phoneMessage(foundStep3Step3phonemessage);

        const foundStep3callmessage = data.includes.Entry.find(
          (entry: any) => entry.fields?.id === 'hs-member-forgot-username-step-3-call-content',
        )?.fields?.content?.content[0]?.content[0]?.value;
        setForgotUsernameStep3callMessage(foundStep3callmessage);
      })
      .catch((err: unknown) => {
        console.error('❌ Contentful Error:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  const errorMessages: ErrorMessagesType = {
    email: {
      required: ForgotUsernameemailError,
      invalid: ForgotUsernamevalidateEmailError,
    },
    lastName: {
      required: ForgotUsernamelastNameError,
      invalid: ForgotUsernamevalidatelastNameError,
    },
    dob: {
      required: ForgotUsernamedobError,
      invalid: ForgotUsernamevalidatedobError,
    },
    tempPin: {
      invalid: ForgotUsernametemporaryPinInvalidError,
    },
  };

  useEffect(() => {
    const emailInput = document.querySelector('leaf-input[name="email"]');
    const lastNameInput = document.querySelector('leaf-input[name="lastName"]');
    const dobInput = document.querySelector('input[name="dob"');
    if (emailInput) emailInput.addEventListener('input', handleChange);
    if (lastNameInput) lastNameInput.addEventListener('input', handleChange);
    if (dobInput) dobInput.addEventListener('leafchange', handleChange);

    return () => {
      if (emailInput) emailInput.removeEventListener('input', handleChange);
      if (lastNameInput) lastNameInput.removeEventListener('input', handleChange);
      if (dobInput) dobInput.removeEventListener('leafchange', handleChange);
    };
  }, []);


  useEffect(() => {
    const tempPinInput = document.querySelector('leaf-input[name="tempPin"]');

    if (tempPinInput) {
      tempPinInput.addEventListener('input', handleChange);
    }

    return () => {
      if (tempPinInput) {
        tempPinInput.removeEventListener('input', handleChange);
      }
    };
  }, [currentStep]);

  const handlepinVerify = async (event: React.FormEvent) => {
    event.preventDefault();

    const otp = formData.tempPin;
    const email = formData.email;

    if (!otp) {
      setErrors((prev) => ({
        ...prev,
        tempPin: ForgotUsernametemporaryPinRequiredError,
      }));
      return;
    }

    if (!/^\d{4,6}$/.test(otp)) {
      setErrors((prev) => ({
        ...prev,
        tempPin: ForgotUsernametemporaryPinInvalidError,
      }));
      return;
    }

    const requestPayload =
      selectMethod === 'sms'
        ? {
            contact: userDetails?.phoneNumber,
            email:userDetails?.email,
            otp,
            method: 'sms' as const,
          }
        : {
            contact: userDetails?.email,
            otp,
            method: 'email' as const,
          };

    const { data, error } = await verifyOtp(requestPayload, transactionId);

    if (data) {
      setSuccess('OTP verified and Username sent to registered email');

      setErrors((prev) => ({
        ...prev,
        general: '',
        tempPin: '',
      }));

      setTimeout(() => {
        loginWithRedirect();
      }, 3000);
    } else {
      console.error(error);

      setErrors((prev) => ({
        ...prev,
        general: error || 'OTP verification failed',
      }));

      setSuccess('');
    }
  };

  const handleSendCode = async () => {
    const method = selectMethod as 'email' | 'sms';

    const contact =
      method === 'sms' ? userDetails?.phoneNumber?.replace(/\s+/g, '') : userDetails?.email?.replace(/\s+/g, '');

    if (!method || !contact) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        general: 'Please select a valid contact method.',
      }));
      return;
    }

    const activeChannel = method === 'sms' ? channel : 'sms';
    console.log("handleSendCode method:", method, "| channel state:", channel, "| sending channel:", activeChannel);

    const { data, error } = await sendOtp(contact, method, activeChannel, transactionId);

    if (data) {
      setSelectMethod(method);
      setCurrentStep(3);
      setErrors((prev) => ({ ...prev, general: '' }));
    } else {
      console.error(error);
      setErrors((prev) => ({
        ...prev,
        general: error || 'Unable to send code. Please try again.',
      }));
    }
  };

  const handlePinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempPin(e.target.value);
  };

  const handleRequestNewCode = async (overrideChannel?: 'sms' | 'call') => {
    const method = selectMethod as 'email' | 'sms';
    const activeChannel = overrideChannel ?? channel;

    const phone = mfaFactors?.app_metadata?.MFA_phone_number?.replace(/\s+/g, '');
    const updatedPhone =
        phone?.startsWith('+1') && phone.length === 13
          ? phone.slice(0, 2) + phone.slice(3) // remove character after +1
          : !phone?.startsWith('+1') && phone?.length === 10
            ? '+1' + phone // add +1 to 10-digit number
            : !phone?.startsWith('+') && phone?.length === 11
              ? '+' + phone // add + to 11-digit number
              : phone;
    const contact =
      method === 'sms'
        ? updatedPhone
        : mfaFactors?.email?.replace(/\s+/g, '');

    if (!method || !contact) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        general: 'Please select a valid contact method.',
      }));
      return;
    }

    const { data, error } = await sendOtp(contact, method, activeChannel, transactionId);
    if (data) {
      if (overrideChannel) setChannel(overrideChannel);
      setSelectMethod(method);
      setCurrentStep(3);
      setErrors((prev) => ({ ...prev, general: '' }));
    } else {
      console.error(error);
      setErrors((prev) => ({
        ...prev,
        general: error || 'Unable to send code. Please try again.',
      }));
    }
  };

  const validateEmail = (email: string): boolean => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const validateName = (name: string) => /^[a-zA-Z\s'-.]+$/.test(name);

  const validateDOB = (dob: string) => {
    const today = new Date();
    const birthDate = new Date(dob);
    const age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    return age > 13 || (age === 13 && month >= 0);
  };

  const handleChange = (event: Event) => {
    const target = event.target as HTMLElement & { value?: string; name?: string };
    const name = target.getAttribute('name') as FieldType;

    let value = '';
    if (target.tagName === 'LEAF-DATE-PICKER') {
      value = (target as any).value || '';
    } else {
      value = (target as HTMLInputElement).value;
    }

    setFormData((prevState) => ({ ...prevState, [name]: value }));
    handleFieldValidation(name, value);
  };

  const validateField = (field: FieldType, value: string) => {
    if (!value) return errorMessages[field].required || '';

    switch (field) {
      case 'email':
        return !validateEmail(value) ? errorMessages.email.invalid : '';
      case 'lastName':
        return !validateName(value) ? errorMessages.lastName.invalid : '';
      case 'dob':
        return !validateDOB(value) ? errorMessages.dob.invalid : '';
      case 'tempPin':
        return !/^\d*$/.test(value) ? errorMessages.tempPin.invalid : '';
      default:
        return '';
    }
  };

  const handleFieldValidation = (field: FieldType, value: string) => {
    const error = validateField(field, value);
    setErrors((prevErrors) => ({ ...prevErrors, [field]: error }));
  };

  const formatDateToISO = (dateStr: string): string => {
    const [year, month, day] = dateStr.split('-');
    if (!month || !day || !year) return '';
    const safeYear = year.length > 4 ? year.slice(0, 4) : year;
    return `${safeYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();


    const emailInput = document.querySelector('leaf-input[name="email"]') as HTMLInputElement;
    let emailValue = emailInput?.value;

    const lastNameInput = document.querySelector('leaf-input[name="lastName"]') as HTMLInputElement;
    let lastNameValue = lastNameInput?.value;

    const dobValue = dobRef.current?.value || '';
    const formattedDOB = formatDateToISO(dobValue);

    formData.email = emailValue;
    formData.lastName = lastNameValue;

    const updatedFormData = {
      ...formData,
      dob: formattedDOB,
      email: emailValue,
      lastName: lastNameValue,
    };

    setFormData(updatedFormData);

    (['email', 'lastName', 'dob'] as FieldType[]).forEach((field) => {
      const value = updatedFormData[field];
      handleFieldValidation(field, value);
    });

    if (!updatedFormData.email || !updatedFormData.lastName || !updatedFormData.dob) return;

    setLoading(true);
    setError(null);

    const newTransactionId = generateUUID();
    setTransactionId(newTransactionId);
    const { data, error } = await getMfaFactors(updatedFormData, newTransactionId);

    setLoading(false);
    setErrors((prevErrors) => ({
      ...prevErrors,
      general: '',
    }));

    if (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        general: error,
      }));
    }

    if (data) {
      const primaryFactor = data.factors;

      setMfaFactors(data.factors);
      const phone = primaryFactor?.app_metadata?.MFA_phone_number;
      const updatedPhone =
        phone?.startsWith('+1') && phone.length === 13
          ? phone.slice(0, 2) + phone.slice(3) // remove character after +1
          : !phone?.startsWith('+1') && phone?.length === 10
            ? '+1' + phone // add +1 to 10-digit number
            : !phone?.startsWith('+') && phone?.length === 11
              ? '+' + phone // add + to 11-digit number
              : phone;
      setUserDetails({
        email: updatedFormData.email,
        phoneNumber: updatedPhone || '',
      });

      setCurrentStep(2);
    }
  };

  const handleBack = () => {
    errors.general = '';
    if (currentStep > 1) {
      if (currentStep === 3) {
        setSelectMethod('email');
        setChannel('sms');
      }
      setCurrentStep((prevStep) => prevStep - 1);
      setSuccess('');
    } else {
      loginWithRedirect();
    }
  };
  function maskEmail(email: string = ''): string {
    const [username, domain] = email.split('@');
    const domainParts = domain.split('.');

    const maskedUser = username.slice(0, 3) + '*'.repeat(Math.max(1, username.length - 2));

    const maskedDomain = domainParts[0].slice(0, 3) + '*'.repeat(Math.max(1, domainParts[0].length - 3));

    return `${maskedUser}@${maskedDomain}.${domainParts.slice(1).join('.')}`;
  }

  function maskPhone(phone: string = ''): string {
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length > 4 ? `${'*'.repeat(cleaned.length - 4)}${cleaned.slice(-4)}` : phone;
  }

  function isValidPhoneNumber(phone: string = ''): boolean {
    const digits = phone.replace(/\D/g, '');
    return digits.length === 10 || digits.length === 11 || digits.length === 12;
  }

  const todayISO = new Date().toISOString().split('T')[0];
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Header />
      <div>
        {currentStep === 1 && (
          <div className="forgot-username-body">
            <div className="forgot-username-container1">

              <img
                src="/static/svgs/logos/healthspring-logo.svg"
                alt="HS_logo"
                className="hs-logo"
              />
              <div className="forgot-username-container-heading">
                <div>{ForgotUsernamestep1text}</div>
              </div>
              <div className="forgot-username-container-description">{ForgotUsernamestep1description}</div>

              {errors.general && (
                <div className="general-error">
                  <div>
                    {errors.general}

                  </div>
                </div>
              )}

              <form>
                <label id="lastNameLabel">Last Name</label>
                <leaf-input
                  type="text"
                  name="lastName"
                  onInput={handleChange}
                  value={formData.lastName}
                  placeholder={ForgotUsernamelastName}
                  required
                />
                {errors.lastName && <div style={{ color: 'red', fontSize: '14px' }}>{errors.lastName}</div>}
                <label id="emailLabel">Email Address</label>
                <leaf-input
                  type="text"
                  name="email"
                  onInput={handleChange}
                  value={formData.email}
                  placeholder={ForgotUsernameEmail}
                  required
                />
                {errors.email && <div style={{ color: 'red', fontSize: '14px' }}>{errors.email}</div>}

                <label id="dobLabel">Date of Birth (MM/DD/YYYY)</label>
                <input
                  ref={dobRef}
                  type="date"
                  name="dob"
                  max={todayISO}
                  defaultValue=""
                  placeholder={ForgotUsernameDateofBirth}
                  onInput={(e: any) => {
                    const val = e.target.value; // Format: YYYY-MM-DD
                    if (val) {
                      const [year, month, day] = val.split('-');

                      // Forces year to current year if it's too long or in the future
                      if (year.length > 4 || Number(year) > currentYear) {
                        e.target.value = `${currentYear}-${month}-${day}`;
                      }
                      //If the full valid date is in the future, reset it to today
                      if (val > todayISO) {
                        e.target.value = todayISO;
                      }
                    }
                  }}
                  required
                />

                {errors.dob && <div style={{ color: 'red', fontSize: '14px' }}>{errors.dob}</div>}

                <div className="forgot-username-buttons1">
                  <button onClick={handleBack} className="back-button">
                    {ForgotUsernameBack}
                  </button>
                  <button type="button" onClick={handleSubmit} className="primary-button">
                    {ForgotUsernameNext}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="forgot-username-body">
            <div className="forgot-username-container">
              <img
                src="/static/svgs/logos/healthspring-logo.svg"
                alt="HS_logo"
                className="hs-logo"
              />
              <div className="forgot-username-container-heading">
                <div style={{ textAlign: 'center' }}>{ForgotUsernamestep2text}</div>
              </div>
              <div className="forgot-username-container-description">{ForgotUsernamestep2description}</div>
              {errors.general && <div className="general-error">{errors.general}</div>}
              <div className="radio-container">
                {mfaFactors?.email && (
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="method"
                      value="email"
                      checked={selectMethod === 'email'}
                      onChange={() => { setSelectMethod('email'); setChannel('sms'); }}
                    />
                    <span className="radio-text">
                    {maskEmail(mfaFactors.email)}
                    </span>
                  </label>
                )}
                {mfaFactors?.app_metadata?.MFA_phone_number && isValidPhoneNumber(mfaFactors.app_metadata.MFA_phone_number) && (
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="method"
                      value="sms"
                      checked={selectMethod === 'sms'}
                      onChange={() => setSelectMethod('sms')}
                    />
                    {maskPhone(mfaFactors.app_metadata.MFA_phone_number)}
                  </label>
                )}
              </div>
              <div className="channel-radio-container">
                {selectMethod === 'sms' && (
                  <div className="channel-container">
                    <p className="channel-heading">{ForgotUsernameStep2channelHeading}</p>
                    <div className="channel-box">
                      <div className="channel-option">
                        <label className="radio-label">
                          <input
                            type="radio"
                            name="channel"
                            value="sms"
                            checked={channel === 'sms'}
                            onChange={(e) => setChannel(e.target.value as 'sms' | 'call')}
                          />
                          Text Message
                        </label>
                      </div>
                      <div className="channel-divider" />
                      <div className="channel-option">
                        <label className="radio-label">
                          <input
                            type="radio"
                            name="channel"
                            value="call"
                            checked={channel === 'call'}
                            onChange={(e) => setChannel(e.target.value as 'sms' | 'call')}
                          />
                          Voice Call
                        </label>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="forgot-username-buttons2">
                <button onClick={handleBack} className="back-button">
                  {ForgotUsernameStep2Back}
                </button>

                <button type="button" onClick={handleSendCode} className="primary-button">
                  {ForgotUsernameStep2sendCode}
                </button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="forgot-username-body">
            <div className="forgot-username-container">
              <img
                src="/static/svgs/logos/healthspring-logo.svg"
                alt="HS_logo"
                className="hs-logo"
              />
              <div className="forgot-username-container-heading">
                <img
                  className="email-icon"
                  src="/static/images/purple_contained_RGB_email.svg"
                  alt="Email icon"
                />
                <div>{selectMethod === 'email' ? ForgotUsernameStep3emailTitle : ForgotUsernameStep3phoneTitle}</div>
              </div>

              <div className="forgot-username-container-description" style={{ textAlign: 'center' }}>
                {selectMethod === 'email'
                  ? (ForgotUsernameStep3emailmessage || '').replace('{{email}}', userDetails.email)
                  : ((channel === 'call' ? ForgotUsernameStep3callMessage : ForgotUsernameStep3phoneMessage) || '').replace(
                      '{{phoneNumber}}',
                      '*'.repeat(userDetails.phoneNumber.length - 4) + userDetails.phoneNumber.slice(-4),
                    )}
              </div>

              {errors.general && <div className="general-error">{errors.general}</div>}

              <p>{ForgotUsernameStep3pinPrompt}</p>
              <form>
                <label>
                  {ForgotUsernameStep3tempPin}
                  <leaf-input
                    type="text"
                    name="tempPin"
                    onChange={handlePinChange}
                    maxLength={6}
                    required
                    placeholder="Enter your verification code"
                  />
                  {errors.tempPin && <div style={{ color: 'red', fontSize: '14px' }}>{errors.tempPin}</div>}
                  {success && <div style={{ color: 'green', fontSize: '20px' }}>{success}</div>}
                </label>
                <div className="forgot-username-buttons3 verification-buttons">
                  <button type="button" onClick={handlepinVerify} className="primary-button continue-button">
                    {ForgotUsernameStep3Next}
                  </button>
                  <button onClick={handleBack} className="back-button try-another-method-button">
                    {ForgotUsernameStep3Back}
                  </button>
                </div>
                <p>
                  {selectMethod === 'sms' ? (channel === 'call' ? ForgotUsernameStep3textPromptCall : ForgotUsernameStep3textPromptSms) : ForgotUsernameStep3textPrompt}{' '}
                  <button type="button" onClick={() => handleRequestNewCode()} className="resend-link-button">
                    {channel === 'call' ? 'Call again' : 'Resend'}
                  </button>
                  {selectMethod === 'sms' && (
                    <>
                      {' or '}
                      <button type="button" onClick={() => handleRequestNewCode(channel === 'sms' ? 'call' : 'sms')} className="resend-link-button">
                        {channel === 'sms' ? 'Get a call' : 'Send a text'}
                      </button>
                    </>
                  )}
                </p>
              </form>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ForgotUsername;
